import {observeAdd, selectArr, selectDoc} from "../utils/utils";
import {initSlider} from "../helpers/service.slider";

const props = {
    pageContainer: selectDoc('#PageContainer'),
    mainContainer: selectDoc('#insta-feed'),
    sliders: selectDoc('.instafeed-slider .glide__slides'),
    sliderConfig: {
        perView: 6,
        gap: '15',
        autoplay: 1,
        animationDuration: 20000,
        animationTimingFunc: 'linear',
        hoverpause: false,
        type: 'carousel',
        focusAt: 'center',
        startAt: 0,
        peek: {
            before: 0,
            after: 0
        },
        breakpoints: {
            767: {
                perView: 2,
                peek: {
                    before: 0,
                    after: 60
                }
            }
        }
    },
}

const observeSlider = (slides) =>  {
    let init = false,
        sliders = 0;
    slides.map(node => {
        if (!node.className.includes('instafeed-lightbox') && node.tagName === 'A') {
            init = true;
            let liNode = document.createElement("li")
            liNode.classList.add('glide__slide')
            liNode.classList.add(node.getAttribute('href').replace('#', 's'))
            liNode.appendChild(node)
            props.sliders.appendChild(liNode)
        } else {
            if (node.tagName === 'A') {
                sliders++;
            }
        }
    })

    if (init) {
        initSlider('.instafeed-slider', props.sliderConfig, true);

        let clonedSliders = selectArr(('.instafeed-slider .glide__slide .js-lazy-image'));
        clonedSliders.map(clone => {
            clone.setAttribute('src', clone.getAttribute('data-src'))
        })
    }
}

const initializer = () => {
    observeAdd(props.mainContainer, observeSlider);
}

export const Instafeed = {
    init: () => initializer()
}
